import React, { PureComponent } from 'react';
import {
        ComposedChart,
        Line,
        Area,
        Bar,
        XAxis,
        YAxis,
        CartesianGrid,
        ResponsiveContainer,
        Tooltip,
} from 'recharts';


export default class Example extends PureComponent {
        constructor(props) {
                super(props);
                this.state = {
                        data: props.data
                }
        }
        render() {
                return (
                        <ResponsiveContainer width="100%" height="100%" minHeight="300px" minWidth="500px">
                                <ComposedChart
                                        width={500}
                                        height={400}
                                        data={this.props.data}
                                >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="range" />
                                        <YAxis />
                                        <Tooltip />
                                        <Area type="monotone" dataKey="count" fill="#8884d8" stroke="#8884d8" />
                                        <Bar dataKey="count" fill="#413ea0" barCategoryGap={0} barGap={0}/>
                                        <Line type="monotone" dataKey="count" stroke="#ff7300"/>
                                </ComposedChart>
                        </ResponsiveContainer>
                );
        }
}
